export default __webpack_public_path__ + "images/751213b0afc112155be71e72157dcdf6-st_patricks_day.webp";